import styled from '@emotion/styled'

const ListItemContainer = styled.li`
  background: ${({ playing, theme }) =>
    playing ? theme.colors.lightGray : 'none'};
  position: relative;
  display: flex;
  margin-bottom: 0.5rem;
  align-items: center;
  transition: background-color 0.1s ease-in-out;
  border-radius: 0.25rem;
  width: 100%;

  .hover-child {
    opacity: 0;
  }

  @media (pointer: fine) {
    .hover-child {
      opacity: 0;
      transition: opacity 0.1s ease-in-out;
    }

    &:hover {
      cursor: pointer;
      background: ${({ theme }) => theme.colors.background};

      .hover-child {
        opacity: 1;
      }
    }
  }
`
export default ListItemContainer
